function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2714"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18475",
  d: "M7.74 68.837a22.994 22.994 0 010-32.525L35.318 8.734a23 23 0 0132.525 32.531L40.265 68.837a22.994 22.994 0 01-32.525 0z",
  fill: "#fb8c00",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2757",
  transform: "translate(-103.999 -21.237)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18509",
  d: "M150 90h-36a1 1 0 01-1-1V61a1 1 0 011-1h35V39a1 1 0 011-1h25a1 1 0 011 1v50a1 1 0 01-1 1z",
  fill: "none",
  stroke: "#fb8c00",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1434",
  width: 33,
  height: 43,
  rx: 4,
  transform: "translate(122 32)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1435",
  width: 33,
  height: 43,
  rx: 4,
  transform: "translate(131 24)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1439",
  width: 4,
  height: 4,
  rx: 1,
  transform: "translate(137 30)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18508",
  d: "M169.901 62.7a9.527 9.527 0 01-5.73-1.9 9.647 9.647 0 01-3.426-4.818h-7.156v1.438a2.4 2.4 0 01-4.8 0v-1.437a1.92 1.92 0 10-3.84 0v3.514a2.401 2.401 0 01-4.8-.158v-3.355a2.882 2.882 0 110-5.764h20.6a9.679 9.679 0 013.426-4.818 9.6 9.6 0 115.73 17.3zm0-14.4a4.8 4.8 0 104.8 4.8 4.8 4.8 0 00-4.8-4.8z",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1436",
  transform: "translate(108 84)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 13,
  height: 13,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1437",
  transform: "translate(130 84)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 13,
  height: 13,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1438",
  transform: "translate(152 84)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 13,
  height: 13,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18516",
  d: "M114.783 85.74V93h-1.518v-5.544l-1.573 1.012-.693-1.133 2.4-1.6z",
  fill: "#fb8c00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18515",
  d: "M133.405 86.51a2.533 2.533 0 012.112-.902 2.517 2.517 0 012.107.9 4.708 4.708 0 01.709 2.9 4.556 4.556 0 01-.7 2.86 2.565 2.565 0 01-2.116.864 2.565 2.565 0 01-2.112-.864 4.556 4.556 0 01-.7-2.86 4.736 4.736 0 01.7-2.898zm3.366 2.871a4.478 4.478 0 00-.286-1.909 1 1 0 00-.962-.544 1.01 1.01 0 00-.968.55 4.407 4.407 0 00-.291 1.9 4.256 4.256 0 00.3 1.892 1.021 1.021 0 00.968.539 1 1 0 00.957-.539 4.4 4.4 0 00.282-1.889z",
  fill: "#fb8c00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18514",
  d: "M158.783 85.74V93h-1.518v-5.544l-1.573 1.012-.693-1.133 2.4-1.6z",
  fill: "#fb8c00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18510",
  d: "M146 30h11",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18511",
  d: "M146 34h11",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18512",
  d: "M137.266 38H157",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18513",
  d: "M137.266 42H157",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgOneToOne = function SvgOneToOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgOneToOne as ReactComponent };